import { atom } from 'jotai';
import { TrackingProvider } from '../types/tracking';

// Define the OrderStatus enum (matching backend)
export enum OrderStatus {
  InProgress = 'in_progress',
  Complete = 'complete',
  Open = 'open',
  Cancelled = 'cancelled',
  Rejected = 'rejected',
}

// Define the types based on the backend DTOs
export interface Order {
  id: string;
  status: OrderStatus;
  estimatedArrivalDate?: string;
  trackingNumber?: string;
  trackingProvider?: TrackingProvider;
  trackingAvailable?: boolean;
  shiptoName?: string;
}

export interface Orders {
  orders: Order[];
}

export const ordersAtom = atom<Orders | null>(null);
